import type { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

import { CenterFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import useColor from '@/hooks/domain/useColor';

export const GptActionButton = styled(Button).attrs({
  sizeType: 's',
  variant: 'outlined',
})``;

export const AvatarWrapper = (props: {
  children: ReactNode;
  size?: number;
  style?: CSSProperties;
}) => {
  const color = useColor();
  const size = props.size || 48;
  return (
    <CenterFlex
      style={{
        width: size,
        height: size,
        backgroundColor: color.FL100,
        boxShadow: `${size / 24}px ${size / 8}px ${size / 4}px ${color.FD16}`,
        borderRadius: 24,
        ...props.style,
      }}
    >
      {props.children}
    </CenterFlex>
  );
};
